import { E_ObservationValueType } from "../../../../../enums/observation/observation-value-type.enum";
import { I_ObservationColorRuleResponse } from "../api/observation-color-rule.response";

export class C_ObservationColorRule {
  valueType!: E_ObservationValueType;

  // Para números
  min?: number;
  max?: number;

  // Para strings
  matchText?: string;

  // Para booleanos
  matchBoolean?: boolean;

  // Para fechas (en formato ISO)
  minDate?: string;
  maxDate?: string;

  // Estética
  color!: string;
  label?: string;

  constructor(obsColrule: I_ObservationColorRuleResponse) {
    if (obsColrule.valueType) this.valueType = obsColrule.valueType;
    if (obsColrule.hasOwnProperty('min')) this.min = obsColrule.min;
    if (obsColrule.hasOwnProperty('max')) this.max = obsColrule.max;
    if (obsColrule.matchText) this.matchText = obsColrule.matchText;
    if (obsColrule.hasOwnProperty('matchBoolean')) this.matchBoolean = obsColrule.matchBoolean;
    if (obsColrule.minDate) this.minDate = obsColrule.minDate;
    if (obsColrule.maxDate) this.maxDate = obsColrule.maxDate;
    if (obsColrule.color) this.color = obsColrule.color;
    if (obsColrule.label) this.label = obsColrule.label;
  }
}

